import { useEffect } from 'react';

import { ShortcutContext, ShortcutKey } from './types';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

interface UseInboxPreviewCompositionProps {
  onSelectReply: () => void;
  onSelectReplyAll: () => void;
  onSelectForward: () => void;
}

export function useInboxPreviewComposition({
  onSelectReply,
  onSelectReplyAll,
  onSelectForward,
}: UseInboxPreviewCompositionProps) {
  const { registerShortcut, unregisterShortcut } = useKeyboardShortcuts();

  useEffect(() => {
    registerShortcut({
      key: ShortcutKey.REPLY,
      contexts: [ShortcutContext.INBOX_PREVIEW],
      handler: () => {
        onSelectReply();
      },
      description: 'Reply to email',
    });

    registerShortcut({
      key: ShortcutKey.REPLY_ALL,
      contexts: [ShortcutContext.INBOX_PREVIEW],
      handler: () => {
        onSelectReplyAll();
      },
      description: 'Reply to all',
    });

    registerShortcut({
      key: ShortcutKey.FORWARD,
      contexts: [ShortcutContext.INBOX_PREVIEW],
      handler: () => {
        onSelectForward();
      },
      description: 'Forward email',
    });

    const ctx = [ShortcutContext.INBOX_PREVIEW];
    return () => {
      unregisterShortcut(ShortcutKey.REPLY, ctx);
      unregisterShortcut(ShortcutKey.REPLY_ALL, ctx);
      unregisterShortcut(ShortcutKey.FORWARD, ctx);
    };
  }, [
    registerShortcut,
    unregisterShortcut,
    onSelectReply,
    onSelectReplyAll,
    onSelectForward,
  ]);
}
